import { render, staticRenderFns } from "./NJ-SL-Disclosure.vue?vue&type=template&id=61866e7c&scoped=true&"
import script from "./NJ-SL-Disclosure.vue?vue&type=script&lang=js&"
export * from "./NJ-SL-Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./NJ-SL-Disclosure.vue?vue&type=style&index=0&id=61866e7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61866e7c",
  null
  
)

export default component.exports